<app-layout>
  <p-toast />

  <div class="home-element">
    <header>
      <h2>
        <i class="pi pi-list-check"></i> Tareas
      </h2>

      <div class="header-actions">
        <span class="view-selector">
          <button
            [class]="'view-selector-button border-primary text-primary ' + (activeView === 'kanban' ? 'view-selector-button-active bg-primary border-primary' : '')"
            (click)="toggleView('kanban')">
            <i class="pi pi-th-large" style="font-size: 1rem;"></i>
          </button>

          <button
            [class]="'view-selector-button border-primary text-primary ' + (activeView === 'table' ? 'view-selector-button-active bg-primary border-primary' : '')"
            (click)="toggleView('table')">
            <i class="pi pi-table" style="font-size: 1rem;"></i>
          </button>
        </span>

        <p-button (click)="isModalVisible = true" type="button" icon="pi pi-plus" styleClass="p-button-rounded">
        </p-button>
      </div>
    </header>

    <div class="search-section">
      <p-iconField iconPosition="left">
        <p-inputIcon>
          <i class="pi pi-search"></i>
        </p-inputIcon>

        <input pInputText type="text" [value]="dataForm.value.search" (input)="onFilterInput($event, 'search')"
          placeholder="Buscar" />
      </p-iconField>

      <p-button (click)="resetFilters()" type="button" icon="pi pi-filter-slash" styleClass="p-button-rounded"
        severity="danger">
      </p-button>
    </div>

    <p-accordion>
      <p-accordionTab header="Filtrar tareas">
        <section class="filters-section" [formGroup]="dataForm">
          <div class="filters-group">
            <span class="p-fluid p-float-label">
              <p-autoComplete label="" [dropdown]="true" [suggestions]="filteredStatus"
                (completeMethod)="filterStatus($event)" field="name" formControlName="status"
                (onSelect)="selectField($event, 'status')" (onClear)="selectField(null, 'status')" appendTo="body"
                [forceSelection]="true" dataKey="id">
              </p-autoComplete>

              <label for="autocomplete">Estatus</label>
            </span>

            <span class="p-fluid p-float-label">
              <p-autoComplete formControlName="task_type" [suggestions]="tasksTypes" [showEmptyMessage]="true"
                appendTo="body" [dropdown]="true" field="name" [minLength]="1" (completeMethod)="filterTask($event)"
                (onSelect)="selectField($event, 'task_type')" (onClear)="selectField(null, 'task_type')"
                [forceSelection]="true" dataKey="id">
              </p-autoComplete>

              <label for="autocomplete">Responsable</label>
            </span>
          </div>
        </section>
      </p-accordionTab>
    </p-accordion>

    <ng-container *ngIf="activeView === 'table'; else kanban">
      <section class="table-container">
        <p-table #dt2 [value]="tasks" dataKey="id" [rows]="dataForm.value.page_size"
          [rowsPerPageOptions]="[10, 20, 30, 50]" [loading]="loading" [paginator]="false" styleClass="p-datatable-sm"
          currentPageReportTemplate="{currentPage} de {totalPages}" [globalFilterFields]="['']">
          <ng-template pTemplate="header">
            <tr>
              <th pSortableColumn="folio" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  #Folio
                  <p-sortIcon field="folio" />
                </p>
              </th>

              <th pSortableColumn="customer.name" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Cliente
                  <p-sortIcon field="customer.name" />
                </p>
              </th>

              <th pSortableColumn="task_type.name" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Responsable
                  <p-sortIcon field="task_type.name" />
                </p>
              </th>

              <th pSortableColumn="title" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Titulo
                  <p-sortIcon field="title" />
                </p>
              </th>

              <th pSortableColumn="user.name" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Usuario
                  <p-sortIcon field="user.name" />
                </p>
              </th>

              <th pSortableColumn="initial_date" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Fecha
                  <p-sortIcon field="initial_date" />
                </p>
              </th>

              <th pSortableColumn="description" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Descripción
                  <p-sortIcon field="description" />
                </p>
              </th>

              <th pSortableColumn="status.name" class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Estado
                  <p-sortIcon field="status.name" />
                </p>
              </th>

              <th class="bg-gray-100 border-bottom">
                <p class="th-inside">
                  Acciones
                </p>
              </th>
            </tr>
          </ng-template>

          <ng-template pTemplate="body" let-task>
            <tr class="text-sm">
              <td>
                <span class="folio">
                  {{ task.folio }}
                </span>
              </td>

              <td>
                {{ task.customer?.name }}
              </td>

              <td>
                {{ task.task_type?.name }}
              </td>

              <td>
                {{ task.title }}
              </td>

              <td>
                {{ task.user?.name }}
              </td>

              <td>
                {{ task.initial_date | date: 'dd/MM/yyyy' }} /{{' '}}
                {{ task.final_date | date: 'dd/MM/yyyy' }}
              </td>

              <td>
                <span class="table-text">{{ task.description }}</span>
              </td>

              <td>
                <p-dropdown [options]="statusOptions" [(ngModel)]="task.status" optionLabel="name"
                  (onChange)="updateTaskStatus(task, $event.value.id)" appendTo="body"
                  [style]="{'width': '100%', 'min-width': '150px'}">
                  <ng-template pTemplate="selectedItem">
                    <span [class]="getStatusClass(task.status)">
                      {{ task.status.name }}
                    </span>
                  </ng-template>
                </p-dropdown>
              </td>

              <td>
                <p-button (click)="viewTaskDetails(task)" type="button" icon="pi pi-eye"
                  styleClass="p-button-rounded p-button-text p-button-sm" pTooltip="Ver detalles" tooltipPosition="top">
                </p-button>
              </td>
            </tr>
          </ng-template>

          <ng-template pTemplate="emptymessage">
            <tr>
              <td colspan="9">
                <p class="emptymessage">No se encontraron tareas</p>
              </td>
            </tr>
          </ng-template>
        </p-table>

        <p-paginator [first]="dataForm.value.firstPage" [rows]="dataForm.value.page_size"
          [rowsPerPageOptions]="[10, 20, 30, 50]" [totalRecords]="dataForm.value.totalRecords"
          (onPageChange)="pageChange($event)" currentPageReportTemplate="{currentPage} de {totalPages}"
          [showJumpToPageDropdown]="true" [showPageLinks]="true" [showJumpToPageInput]="true"></p-paginator>
      </section>
    </ng-container>

    <ng-template #kanban>
      <div class="kanban-container">
        <div *ngFor="let column of kanbanColumns" class="kanban-list"
          [class.drag-over]="dragOverColumnId === column.statusId" (drop)="onDrop($event, column.statusId)"
          (dragover)="onDragOver($event, column.statusId)" (dragleave)="onDragLeave($event)">
          <div class="list-header" [style]="{ 'border-top-color': column.color }">
            <h3>{{ column.title }}</h3>
            <p><strong>Número de tareas: </strong>{{ column.total || 0 }}</p>
          </div>

          <section class="kanban-cards">
            <article *ngFor="let task of column.tasks" class="kanban-card" draggable="true"
              (dragstart)="onDragStart($event, task)" (dragend)="onDragEnd($event)">
              <header>
                <div class="kanban-card-folio">
                  <h4 class="kanban-card-title">{{ task.folio }}</h4>
                  <p class="kanban-card-date">
                    {{ task.initial_date | date: 'dd/MM/yyyy' }} - {{ task.final_date | date: 'dd/MM/yyyy' }}
                  </p>
                </div>

                <div class="kanban-card-actions">
                  <button pButton type="button" icon="pi pi-eye" class="p-button-rounded p-button-text p-button-sm"
                    (click)="viewTaskDetails(task)" pTooltip="Ver detalles" tooltipPosition="top">
                  </button>
                </div>
              </header>

              <main>
                <p><strong>Cliente:</strong> {{ task.customer?.name }}</p>
                <p><strong>Responsable:</strong> {{ task.task_type?.name }}</p>
                <p><strong>Título:</strong> {{ task.title }}</p>
                <p><strong>Usuario:</strong> {{ task.user?.name }}</p>
                <p class="task-description"><strong>Descripción:</strong> {{ task.description }}</p>
              </main>

              <footer>
                <span [class]="getStatusClass(task.status)">
                  {{ task.status.name }}
                </span>
              </footer>
            </article>

            <div *ngIf="column.loading" class="kanban-loading">
              <i class="pi pi-spin pi-spinner" style="font-size: 2rem"></i>
            </div>
          </section>

          <div *ngIf="column.currentPage < column.totalPages" class="kanban-load-more">
            <button type="button" (click)="loadMoreKanbanItems(column)" [disabled]="column.loading">
              <i class="pi pi-angle-down"></i>
              Cargar más
            </button>
          </div>
        </div>
      </div>
    </ng-template>

    <p-dialog [modal]="true" [(visible)]="isModalVisible" [style]="{ width: '50%', 'min-width': '30rem' }">
      <ng-template pTemplate="header">
        <div class="dialog-header">
          <span class="dialog-header-title">
            <i class="pi pi-list-check"></i> Agregar nueva tarea
          </span>
        </div>
      </ng-template>

      <form [formGroup]="taskForm" novalidate (submit)="handleSave($event)" class="form">
        <div class="mt-4 mb-4">
          <span class="p-fluid p-float-label">
            <input pInputText type="text" placeholder="Título" formControlName="title" class="w-full" />

            <label for="title">
              Título
            </label>
          </span>
        </div>

        <div class="form-group mt-4 mb-4">
          <span class="p-fluid p-float-label">
            <p-calendar [readonlyInput]="true" appendTo="body" formControlName="initial_date"
              [showIcon]="true"></p-calendar>

            <label>
              Fecha de inicio
            </label>
          </span>

          <span class="p-fluid p-float-label">
            <p-calendar [readonlyInput]="true" appendTo="body" formControlName="final_date"
              [showIcon]="true"></p-calendar>

            <label>
              Fecha de finalización
            </label>
          </span>
        </div>

        <div class="form-group mt-4 mb-4">
          <span class="p-fluid p-float-label">
            <p-autoComplete formControlName="task_type" [suggestions]="tasksTypes" [showEmptyMessage]="true"
              appendTo="body" [dropdown]="true" field="name" [minLength]="1" (completeMethod)="filterTask($event)">
            </p-autoComplete>

            <label for="autocomplete">
              Responsable
            </label>
          </span>

          <span class="p-fluid p-float-label">
            <p-autoComplete formControlName="areas" [suggestions]="nestingAreas" [showEmptyMessage]="true"
              appendTo="body" [dropdown]="true" field="name" [minLength]="1" [multiple]="true"
              (completeMethod)="filterArea($event)">
            </p-autoComplete>

            <label for="autocomplete">
              Áreas
            </label>
          </span>
        </div>

        <div class="w-full mt-4 mb-4">
          <textarea rows="3" pInputTextarea placeholder="Descripción" formControlName="description" class="w-full">
          </textarea>
        </div>

        <div class="button-group mt-4">
          <button pButton pRipple type="submit" [disabled]="taskForm.invalid" label="Guardar" class="p-button-raised"
            size="small"></button>

          <button (click)="isModalVisible = false" pButton pRipple type="button" label="Cancelar"
            class="p-button-raised p-button-secondary" size="small"></button>
        </div>
      </form>
    </p-dialog>
  </div>
</app-layout>